// for location maps
export const UPDATE_PLACE_CLICKED = 'UPDATE_PLACE_CLICKED';
export const UPDATE_SHOW_ALL_PLACES = 'UPDATE_SHOW_ALL_PLACES';
export const UPDATE_SELECTED_PLACE = 'UPDATE_SELECTED_PLACE';
export const RESET_SELECTED_PLACES = 'RESET_SELECTED_PLACES';
export const SHOW_ONLY_USER_SELECTED_LOCATIONS = 'SHOW_ONLY_USER_SELECTED_LOCATIONS';
export const SHOW_ALL_NEARBY_PLACES = 'SHOW_ALL_NEARBY_PLACES';

export interface SelectedPlace {
  n: string;
  crd: [number, number];
  _id: string;
  type: string;
  distanceFromHotel?: string;
  timeFromHotel?: string;
}

export enum GoogleMapLocationType {
  attraction = 'attraction',
  transit = 'transit',
  userSelected = 'usesSelected',
}

export interface MapsStateShape {
  selectedPlaces: Array<any>; // update this before committing map autosuggest
  showAllPlaces: boolean;
}

export interface IUPDATE_PLACE_CLICKED {
  type: typeof UPDATE_PLACE_CLICKED;
  place: object;
}

export interface IUPDATE_SELECTED_PLACE {
  type: typeof UPDATE_SELECTED_PLACE;
  place: object;
}

export interface IUPDATE_SHOW_ALL_PLACES {
  type: typeof UPDATE_SHOW_ALL_PLACES;
  showAllPlaces: boolean;
}

export interface IRESET_SELECTED_PLACES {
  type: typeof RESET_SELECTED_PLACES;
}

export interface ISHOW_ONLY_USER_SELECTED_LOCATIONS {
  type: typeof SHOW_ONLY_USER_SELECTED_LOCATIONS;
}

export interface ISHOW_ALL_NEARBY_PLACES {
  type: typeof SHOW_ALL_NEARBY_PLACES;
  payload: {
    selectedPlaces: Array<any>; // change this
  };
}

export type MapsActionTypes =
  | IUPDATE_SELECTED_PLACE
  | IRESET_SELECTED_PLACES
  | ISHOW_ALL_NEARBY_PLACES
  | ISHOW_ONLY_USER_SELECTED_LOCATIONS;
